import { render, staticRenderFns } from "./delzlgl.vue?vue&type=template&id=769a90f2&scoped=true&"
import script from "./delzlgl.vue?vue&type=script&lang=js&"
export * from "./delzlgl.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "769a90f2",
  null
  
)

export default component.exports